<template>
  <div class="clientele">
    <banner url="clientele" clazz="clientele-banner">
    </banner>
    <div class="clientele-con">
      <div class="box-top clearfix">
        <!--          <div class="box-top-title clearfix">-->
        <!--            <div class="top-left">-->
        <!--              <el-tag closable v-if="industryName === '' ? false : true " @close="isClear('industry')" >{{industryName}}</el-tag>-->
        <!--              <el-tag closable v-if="districtName === '' ? false : true " @close="isClear('district')" >{{districtName}}</el-tag>-->
        <!--            </div>-->
        <!--            <div class="top-right clearfix">-->
        <!--                <div class="title-one cp fentSize" @click="industryClick" >-->
        <!--                  <span style="padding-top:7px;">所有行业</span>-->
        <!--                  <img src="../../assets/img/company/companyicon2.png" alt="所有行业" class="title-one-img" />-->
        <!--                </div>-->
        <!--                <div class="title-three cp fentSize" @click="districtClick">-->
        <!--                  <span style="padding-top:7px;">公司所在地</span>-->
        <!--                  <img src="../../assets/img/company/companyicon2.png" alt="公司所在地" class="title-one-img" />-->
        <!--                </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <div class="top-tab">
          <span @click="districtClick" :class="topLightStyle">标杆客户</span>
          <span @click="industryClick" :class="lightStyle">行业选择 <img
            src="../../assets/img/clientele/up.svg" alt="行业选择"></span>
        </div>
        <el-button class="top-button" @click="goRegister('anliliebiao-banner-xiangqing')">获取案例详情</el-button>
      </div>
      <div class="checkDiv" v-if="industryShow" @mouseleave="industryClick">
          <span :class="{IsclickClass: industry === item.id}" v-for="item in industryCon"
                @click="Isclick(item,'industry')" :key="item.id" class="cp">{{item.name}}</span>
      </div>
      <!--      <div class="checkDiv" v-if="districtShow">-->
      <!--          <span :class="{IsclickClass: district === item.id}" v-for="item in districtCon"-->
      <!--                @click="Isclick(item,'district')" :key="item.id" class="cp">{{item.name}}</span>-->
      <!--      </div>-->
      <div class="clientele-box">
        <div class="box-bottom">
          <div v-if="IsHaveData" class="content-dynamic clearfix" id="box-bottom">
            <a class="dynamic-div cp db" :href="getCaseDetile(item)"
               target="_blank"
               v-for="item in dataList" :key="item.id">
              <div class="dynamic-div-img"
                   :style="{'backgroundImage': 'url(' + $global.globalPath + item.keh_img + ')'}">
                <!--                  <div class="dynamic-div-mask">-->
                <!--                    <img v-lazy="$global.globalPath + item.keh_logo" alt="甄云客户案例" style="width:240px;height:110px" />-->
                <!--                  </div>-->
              </div>
              <div class="dynamic-div-title">
                <!--                  <div class="div-title-top">-->
                <!--                    <span>{{item.industry_name}}</span>-->
                <!--                    <span>|</span>-->
                <!--                    <span>{{item.title}}</span>-->
                <!--                  </div>-->
                <div class="dynamic-div-logo">
                  <img v-lazy="$global.globalPath + item.keh_logo" alt="甄云客户案例"/>
                </div>
                <div class="div-title-bottom">
                  <p>{{item.keh_describe}}</p>
                </div>
              </div>
            </a>
            <div class="dynamic-more" v-show="IsMore">
              <span @click="upCallback" :loading="IsloadMore">加载更多<img src="../../assets/img/clientele/loadMore.png"
                                                                       alt="加载更多"></span>
            </div>
          </div>
          <div class="content-dynamic-box" v-if="!IsHaveData">
            <img src="../../assets/img/clientele/clienteleImg.png" alt="甄云客户案例" style="margin-top:20px"/>
            <div class="dynamic-box-top">
              <span class="box-top-one">sorry，案例暂未上传， </span>
              <span class="box-top-two cp" @click="gitConData">返回案例总页面</span>
            </div>
            <div class="dynamic-box-bottom">
              <span class="box-bottom-one">您也可拨打</span>
              <span class="box-bottom-two">400-116-0808</span>
              <span class="box-bottom-three">获取该行业相关案例</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'clientele',
  metaInfo () {
    return {
      title: this.$seo.clientele.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.clientele.keywords
      },
      {
        name: 'description',
        content: this.$seo.clientele.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      seaData: '',
      route: this.$route.name.toLowerCase(),
      bannerData: [],
      industry: '',
      product: '',
      district: '',
      industryCon: this.$store.state.industryCon || [],
      districtCon: this.$store.state.districtCon || [],
      page: 1,
      size: 15,
      dataList: this.$store.state.clientDataList || [], // 列表数据
      industryShow: false,
      lightStyle: '',
      // districtShow: false,
      industryName: '',
      districtName: '',
      IsHaveData: true,
      IsloadMore: false,
      IsMore: true,
      is_star: 1,
      topLightStyle: 'top-light-style'
    }
  },
  created () {
    if (!this.industryCon.length) {
      this.getIndustryConData()
    }
    if (!this.districtCon.length) {
      this.getDistrictConData()
    }
  },
  mounted () {
    this.upCallback()
    this.industryCon.unshift({
      id: '',
      name: '全部行业'
    })
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    gitConData () {
      this.IsHaveData = true
      this.page = 1
      this.industry = ''
      this.district = ''
      this.industryName = ''
      this.districtName = ''
      this.upCallback()
    },
    upCallback () {
      this.IsloadMore = true
      this.IsMore = true
      let a = {
        webname: 'Clientele',
        is_star: this.is_star,
        count: this.size,
        page: this.page,
        industry: this.industry,
        district: this.district
      }
      this.$api.post('/cases/cases_list', a, (r) => {
        if (r.code === 0) {
          this.IsHaveData = true
          // 请求的列表数据
          let arr = r.data.data
          // 如果是第一页需手动制空列表
          if (this.page === 1) {
            this.dataList = []
          }
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(arr)
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.page += 1
          if (parseInt(r.data.cur_page) === r.data.pages) {
            this.IsMore = false
          }
          this.IsloadMore = false
        } else if (r.code === 9) {
          this.IsMore = false
        } else if (r.code === 10) {
          this.IsHaveData = false
        } else {
        }
      })
    },
    industryClick () {
      this.lightStyle = this.lightStyle ? '' : 'light-style'
      this.industryShow = !this.industryShow
      this.is_star = ''
      this.topLightStyle = ''
    },
    districtClick () {
      this.is_star = 1
      this.lightStyle = ''
      this.industryShow = false
      this.topLightStyle = 'top-light-style'
      this.gitConData()
    },
    Isclick (item, name) {
      this.industryShow = false
      this.page = 1
      if (name === 'industry') {
        this.industry = item.id
        this.industryName = item.name
      }
      if (name === 'district') {
        this.district = item.id
        this.districtName = item.name
      }
      this.upCallback()
    },
    isClear (name) {
      this.page = 1
      if (name === 'industry') {
        this.industryName = ''
        this.industry = ''
      }
      if (name === 'district') {
        this.district = ''
        this.districtName = ''
      }
      this.upCallback()
    },
    getIndustryConData () {
      this.$api.post('/cases/cases_industry', '', (r) => {
        if (r.code === 0) {
          this.industryCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getDistrictConData () {
      this.$api.post('/cases/cases_district', '', (r) => {
        if (r.code === 0) {
          this.districtCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getCaseDetile (item) {
      let routeUrl = this.$router.resolve({
        name: 'ClienteleDetile',
        query: {
          id: item.id
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    caseDetile (item) {
      let routeUrl = this.$router.resolve({
        name: 'ClienteleDetile',
        query: {
          id: item.id
        }
      })
      window.open(routeUrl.href, '_blank')
      //        if (item.status === '0') {
      //          this.$router.push({
      //            name: 'ClienteleDetile',
      //            query: {
      //              id: item.id
      //            }
      //          })
      //        } else if (item.status === '1') {
      //          this.$api.post('/cases/twenty_four_hour', '', (r) => {
      //            if (r.code === 0) {
      //              if (r.data === 1) {
      //              } else {
      //                this.openRegister()
      //              }
      //            } else {
      //              this.$message.error(r.message)
      //            }
      //          })
      //        } else {
      //
      //        }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/clientele.scss";
</style>



// WEBPACK FOOTER //
// clientele.vue?70c253f6